// extracted by mini-css-extract-plugin
module.exports = {"track":"Track_track__K8Hsq","name":"Track_name__8bmbe"};